import type { TagProductReview } from '~~/types/integrations/tagManager/TagProductReview';

export const buildReviewProductTags = (eventName: string, productTags: TagProductReview) => ({
  event: eventName,
  ...productTags,
});
